<template>
  <component :is="resolveLayout">
    <router-view></router-view>
    <ToastError />
    <ToastNotify />
  </component>
</template>

<script>
import { computed } from 'vue';
import {
  useRouter, useStore, useSystemTheme, useVuetify,
} from '@/use';
import ToastError from '@/components/ToastError.vue';
import ToastNotify from '@/components/ToastNotify.vue';
import LayoutBlank from '@/layouts/Blank.vue';
import LayoutContent from '@/layouts/Content.vue';
import LayoutUpdate from '@/layouts/Update.vue';

export default {
  components: {
    LayoutBlank,
    LayoutContent,
    LayoutUpdate,
    ToastError,
    ToastNotify,
  },
  setup() {
    const { route } = useRouter();

    const store = useStore();

    const isDarkMode = useSystemTheme();
    const vuetify = useVuetify();

    store.dispatch('auth/INIT_auth', {
      client_id: process.env.VUE_APP_CLIENT_ID,
      client_secret: process.env.VUE_APP_CLIENT_SECRET,
      url: process.env.VUE_APP_APIURL,
    });

    const resolveLayout = computed(() => {
      if (process.env.VUE_APP_APPMAINTENANCE === 'true') return 'layout-update';

      // Handles initial route
      if (route.value.name === null) return null;

      if (route.value.meta.layout === 'blank') return 'layout-blank';

      return 'layout-content';
    });

    // Set Vuetify theme to dark if isDarkMode
    if (isDarkMode) {
      vuetify.theme.dark = true;
    }

    return {
      resolveLayout,
    };
  },
};
</script>
